import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { connect } from 'react-redux';
import { Link as ReactLink } from 'react-router-dom';

import {
    Title,
    Link,
} from 'yurstrap';

import ModalLink from '../../../components/ModalLink';

import Routes from '../../constants/Routes';
import { getScopeSelector } from '../../../commons/reduxModules/Authentication';
import Scopes from '../../../constants/Scopes';
import BackLink from '../BackLink';

const propTypes = {
    questions: PropTypes.array,
    scope: PropTypes.string.isRequired,
};

const defaultProps = {
    questions: [{
        id: 1,
        title: '1- Comment intégrer mes réservations Yurplan sur un site internet/blog?',
        link: 'https://aide.yurplan.com/article/109-comment-integrer-reservations-sur-mon-site-internet-blog',
    }, {
        id: 2,
        title: '2- Comment créer un événement?',
        link: 'https://aide.yurplan.com/article/95-comment-creer-un-evenement',
    }, {
        id: 3,
        title: '3- Comment intégrer une billetterie Yurplan sur ma page Fan Facebook?',
        link: 'https://aide.yurplan.com/article/105-comment-integrer-une-billetterie-yurplan-sur-ma-page-facebook',
    }, {
        id: 4,
        title: '4- Comment rembourser mes participants?',
        link: 'https://aide.yurplan.com/article/138-comment-rembourser-participants',
    }, {
        id: 5,
        title: '5- Comment créer un tarif?',
        link: 'https://aide.yurplan.com/article/94-comment-creer-un-tarif',
    }, {
        id: 6,
        title: '6- Comment personnaliser la page de mon événement ?',
        link: 'https://aide.yurplan.com/article/112-comment-personnaliser-la-page-de-mon-evenement',
    }],
};
class ContactSupportFAQ extends Component {

    renderItems() {
        const { questions } = this.props;
        return _.map(questions, (question) => (
            <li className="pb-3" key={question.id}>
                <Link
                    className="u-color__grey--60"
                    href={question.link}
                    target="_blank"
                >
                    {question.title}
                </Link>
            </li>
        ));
    }

    render() {
        const { scope } = this.props;
        const linkProps = {
            componentClass: ReactLink,
        };
        if (Scopes.USER !== scope) {
            linkProps.componentClass = ModalLink;
            linkProps.modalName = 'support';
        }
        return (
            <>
                <div className="px-4 py--m-5 px--s-3 u-col--m-7 u-col--s-12 u-bg__white" style={{ paddingTop: '120px' }}>
                    <div>
                        <BackLink
                            className="u-display__none u-display__b--s u-display__b--m mb-4"
                            to={Routes.SUPPORT_ROOT.link}
                            style={{ position: 'initial', top: 'auto' }}
                        />
                    </div>
                    <Title>
                        Questions fréquentes
                    </Title>
                    <ul className="m-0">
                        {this.renderItems()}
                        <li>
                            <Link
                                className="u-color__grey--60"
                                to={Routes.CONTACT_BY_EMAIL.link}
                                /* eslint-disable-next-line react/jsx-props-no-spreading */
                                {...linkProps}
                            >
                                7- J’ai une autre question
                            </Link>
                        </li>
                    </ul>
                </div>
            </>
        );
    }

}

ContactSupportFAQ.propTypes = propTypes;
ContactSupportFAQ.defaultProps = defaultProps;

function mapStateToProps(state) {
    return {
        scope: getScopeSelector(state),
    };
}

export default connect(
    mapStateToProps,
)(ContactSupportFAQ);
